import { normalizeDashboardInsights, type DashboardInsights } from '@tracedocuments/types';
import type { DashboardStatsDto } from './documents';
import { apiFetchWithTimeout } from './fetch-timeout';
import type { StorageSummaryDto } from './storage';

export async function fetchDashboardInsights(): Promise<DashboardInsights> {
  const res = await apiFetchWithTimeout('/api/dashboard/insights');
  if (!res.ok) {
    throw new Error(`Failed to fetch dashboard insights (${res.status})`);
  }
  const raw = await res.json();
  const normalized = normalizeDashboardInsights(raw);
  if (!normalized) {
    throw new Error('Invalid dashboard insights payload');
  }
  return normalized;
}

export type DashboardSummary = {
  insights: DashboardInsights;
  stats: DashboardStatsDto;
  storage: StorageSummaryDto;
};

/** Fase 5 BFF — one round-trip for insights + KPI stats + storage. */
export async function fetchDashboardSummary(): Promise<DashboardSummary> {
  const res = await apiFetchWithTimeout('/api/dashboard/summary');
  if (!res.ok) {
    throw new Error(`Failed to fetch dashboard summary (${res.status})`);
  }
  const raw = (await res.json()) as {
    insights?: unknown;
    stats?: DashboardStatsDto;
    storage?: StorageSummaryDto;
  };
  const insights = normalizeDashboardInsights(raw.insights);
  if (!insights || !raw.stats || !raw.storage) {
    throw new Error('Invalid dashboard summary payload');
  }
  return { insights, stats: raw.stats, storage: raw.storage };
}
